import { SpmMetrics, SpmValueTypes } from '@logz-pkg/enums';
export class ApmRecord {
    id;
    envId;
    entityId;
    values;
}
export class ApmDataMetrics {
    impactLevel;
    impactValue;
    [SpmMetrics.Latency];
    [SpmMetrics.Throughput];
    [SpmMetrics.ErrorRate];
}
export class ApmDataMetricsResponse {
}
export class ApmDataValues {
    [SpmValueTypes.Current];
    [SpmValueTypes.Past];
    [SpmValueTypes.CurrentAvg];
    [SpmValueTypes.PastAvg];
}
//# sourceMappingURL=apm-record.js.map